import { useQuery } from 'data-fetching-client';
import { CURRENCY } from 'pricing-pages-api/EarlyRequesterNames';
import { GET_IN_APP_CURRENCIES, GET_PUBLIC_CURRENCIES } from 'pricing-pages-api/currency/queries';
import { useGetCurrencyStore, useSetCurrencyStore } from '../context/CurrencyContext';
import { useSetOneGlobalLoadingState } from '../context/GlobalLoadingStateContext';
import { getBrowserLocale } from '../utils/getBrowserLocale';
const UseSetLoadingCurrencyComplete = () => {
  const loadingCompletedCallback = useSetOneGlobalLoadingState('Currencies');
  const setStore = useSetCurrencyStore();
  const handleCurrencyFetchCompleted = ({
    currencies
  }) => {
    setStore(currencies);
    loadingCompletedCallback();
  };
  return handleCurrencyFetchCompleted;
};
export const useInAppCurrencies = () => {
  const handleCurrencyFetchCompleted = UseSetLoadingCurrencyComplete();
  const {
    data,
    error,
    loading
  } = useQuery(GET_IN_APP_CURRENCIES, {
    variables: {
      earlyRequestName: CURRENCY
    },
    onCompleted: handleCurrencyFetchCompleted
  });
  const currencyData = data && data.currencies;
  return {
    currencyData,
    error,
    loading
  };
};
export const usePublicCurrencies = () => {
  const {
    browserLocale,
    preferredCountryCode
  } = getBrowserLocale();
  const handleCurrencyFetchCompleted = UseSetLoadingCurrencyComplete();
  const {
    data,
    error,
    loading
  } = useQuery(GET_PUBLIC_CURRENCIES, {
    variables: {
      earlyRequestName: CURRENCY,
      browserLocale,
      preferredCountryCode
    },
    onCompleted: handleCurrencyFetchCompleted
  });
  const currencyData = data && data.currencies;
  return {
    currencyData,
    error,
    loading
  };
};
export const usePricingPageCurrencies = ({
  isAppAuth
}) => {
  const queryHookToUse = isAppAuth ? useInAppCurrencies : usePublicCurrencies;
  return queryHookToUse();
};
export const useDisplayedCurrencyCode = () => {
  const currencyCode = useGetCurrencyStore(store => store.displayedCurrencyCode);
  return currencyCode;
};
export const useLockedCurrencyCode = () => {
  const currencyCode = useGetCurrencyStore(store => store.lockedCurrencyCode);
  return currencyCode;
};
export const useCurrencyCodeUnitToDisplay = () => {
  const currencyCodeUnit = useGetCurrencyStore(store => store.currencyCodeUnit);
  const showCurrencyCodeUnit = useGetCurrencyStore(store => store.showCurrencyCodeUnit);
  return showCurrencyCodeUnit ? currencyCodeUnit : undefined;
};
export const useAvailableCurrencyCodes = () => {
  const availableCurrencyCodes = useGetCurrencyStore(store => store.availableCurrencyCodes);
  return availableCurrencyCodes;
};

//  countryCode?: string | null | undefined;
export const useCountryCode = () => {
  const countryCode = useGetCurrencyStore(store => store.countryCode);
  return countryCode;
};